import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        customerData: {},
        watcher: null,
    },
    mutations: {
        setCustomerData(state, value) {
            state.customerData = value;
        },
        setWatcher(state, value) {
            state.watcher = value;
        },
    },
    actions: {
        validatePriceGroup({commit}, {addressData}) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation($addressData: CustomerBillingAddressInput!) {
                            validatePriceGroup(addressData: $addressData) {
                                success,
                                updateToken,
                                token
                            }
                        }
                    `,
                    variables: {
                        addressData,
                    },
                })
                .then(r => r.data)
                .then(result => {
                    if (result.validatePriceGroup.success && result.validatePriceGroup.updateToken) {
                        commit('Login/setAuthToken', result.validatePriceGroup.token, { root: true });
                        Vue.$basket.sync(false, true);
                    }
                })
                .catch((e) => {
                    console.log('Error', e);
                    return {};
                });
        },
        registerCustomer({}, data) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation($data: NewCustomerInput!, $language: String!, $uid: String, $country: String) {
                            registrationBusiness(data: $data, language: $language, uid: $uid, country: $country) {
                                token
                                success
                                errors
                            }
                        }
                    `,
                    variables: {
                        data,
                        language: Vue.$language.getLanguage(),
                        uid: Vue.$store.getters['Registration/getUid'],
                        country: Vue.$store.getters['BillingAddressForm/getCountry'],
                    },
                })
                .then(r => r.data.registrationBusiness);
        },
        loadCustomerData({state, commit, dispatch, rootGetters}) {
            if (rootGetters['Login/isUserLoggedIn']) {
                if (state.watcher) {
                    state.watcher();
                }

                let watcher = Vue.$store.watch(
                    () => rootGetters['Login/isUserLoggedIn'],
                    (value) => {
                        if (!value) {
                            commit('setCustomerData', {});
                        } else {
                            dispatch('loadCustomerData');
                        }
                    }
                );

                commit('setWatcher', watcher);

                return Vue.$graphql
                    .query({
                        query: gql`
                            query customer {
                                customer {
                                    email
                                    firstName
                                    nickname
                                    lastName
                                }
                            }
                        `
                    })
                    .then(r => r.data.customer)
                    .then(data => {
                        commit('setCustomerData', data);

                        return data;
                    })
                    .catch((e) => {
                        commit('setCustomerData', {});
                    });
            } else {
                return new Promise(resolve => resolve(state.customerData));
            }
        },
    },
};
